import { api } from '../index';

export const create = data => api.post('/review/create', data);

export const update = data => api.post('/review/update', data);

export const getListByCompany = (companyId, params) => api.get(`/review/list/${companyId}`, { params });
